import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VBtn,_vm._g(_vm._b({staticStyle:{"margin-left":"5px"},attrs:{"tile":"","elevation":"2","to":_vm.to,"color":_vm.color,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.clickHandler}},'v-btn',attrs,false),on),[_c(VIcon,[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)]}}])},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }